import React from "react";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import AccountCircle from "@mui/icons-material/AccountCircle";
import MoreIcon from "@mui/icons-material/MoreVert";
import { useAuth } from "../../hooks/AuthProvider";
import { useNavigate } from "react-router-dom";
import { 
  GrowContainer, 
  DesktopSection, 
  MobileSection 
} from "./styles/HeaderStyles";
import { HeaderMenu } from "./HeaderMenu";
import { MenuState } from "./types/HeaderTypes";

export const Header: React.FC = () => {
  const [menuAnchors, setMenuAnchors] = React.useState<MenuState>({
    desktop: null,
    mobile: null,
  });
  const auth = useAuth();
  const navigate = useNavigate();

  const isDesktopMenuOpen = Boolean(menuAnchors.desktop);
  const isMobileMenuOpen = Boolean(menuAnchors.mobile);

  const handleProfileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchors((prev) => ({ ...prev, desktop: event.currentTarget }));
  };

  const handleMobileMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setMenuAnchors((prev) => ({ ...prev, mobile: event.currentTarget }));
  };

  const handleMenuClose = () => {
    setMenuAnchors({ desktop: null, mobile: null });
  };

  const handleProfile = () => {
    navigate("/managers-view");
  };

  const handleLogout = () => {
    auth.logout();
  };

  const menuId = "primary-search-account-menu";
  const mobileMenuId = "primary-search-account-menu-mobile";

  return (
    <GrowContainer>
      <AppBar position="static" color="default">
        <Toolbar>
          <GrowContainer />
          <DesktopSection>
            <IconButton
              edge="end"
              aria-label="account of current user"
              aria-controls={menuId}
              aria-haspopup="true"
              onClick={handleProfileMenuOpen}
              color="inherit"
              size="large">
              <AccountCircle />
            </IconButton>
          </DesktopSection>
          <MobileSection>
            <IconButton
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
              size="large">
              <MoreIcon />
            </IconButton>
          </MobileSection>
        </Toolbar>
      </AppBar>
      <HeaderMenu
        anchorEl={menuAnchors.mobile}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        menuId={mobileMenuId}
        isOpen={isMobileMenuOpen}
        onClose={handleMenuClose}
        onProfile={handleProfile}
        onLogout={handleLogout}
        isMobile
      />
      <HeaderMenu
        anchorEl={menuAnchors.desktop}
        anchorOrigin={{ vertical: "top", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        menuId={menuId}
        isOpen={isDesktopMenuOpen}
        onClose={handleMenuClose}
        onProfile={handleProfile}
        onLogout={handleLogout}
      />
    </GrowContainer>
  );
}; 